<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading" />
    <vs-card>
      <div slot="header">
        <h3 class="card-title mb-0">Datos del tercero</h3>
      </div>
      <div class="columns">
        <div class="column search-control">
          <b-field label="Buscar tercero">
            <div class="control-content">
              <EntityAutocomplete v-model="entity" label="name" />
            </div>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Identificación*">
            <b-input
              placeholder="Identificación"
              type="text"
              v-model="entity.identification"
              :readonly="true"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Nombres*">
            <b-input
              placeholder="Nombres"
              type="text"
              v-model="entity.name"
              :disabled="true"
            />
          </b-field>
        </div>
      </div>
    </vs-card>
    <vs-card>
      <div slot="header">
        <h3 class="card-title mb-0">Datos de acceso</h3>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Empresa*">
            <treeselect
              :options="companiesList"
              :show-count="true"
              :multiple="true"
              :flat="true"
              v-model="companiesIds"
              :limit="4"
              :allowClearingDisabled="true"
              placeholder="Seleccione empresa y/o parqueadero"
              @select="select"
              @deselect="deselect"
            />
          </b-field>
        </div>
        <div class="column">
          <b-field label="Estado*">
            <b-select
              placeholder="Estado"
              expanded
              name="status"
              v-model="selectedStatus"
            >
              <option
                v-for="option in statusList"
                :value="option.code"
                :key="option.code"
                :id="option.code"
              >
                {{ option.title }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Correo electrónico*">
            <b-input
              placeholder="Correo electrónico"
              type="text"
              name="email"
              v-model="email"
              value="email"
            />
          </b-field>
        </div>
      </div>
      <div
        class="columns"
        :key="forceRender"
        v-if="selectedAccess && selectedAccess.length > 0"
      >
        <vs-tabs v-model="currentTab">
          <vs-tab
            v-for="(access, index) in selectedAccess"
            :label="access.company.name"
            :key="index"
          >
            <CompanyOptions :access-detail="access" />
            <div class="columns">
              <div class="column text-right">
                <b-button
                  @click="deleteCompany(index, access.company)"
                  type="is-danger"
                >
                  Eliminar {{ access.company.name }}
                </b-button>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vs-card>
    <vs-card>
      <div class="columns">
        <div class="column">
          <b-button @click="save" type="is-success"> Guardar usuario </b-button>
        </div>
      </div>
    </vs-card>
  </vs-row>
</template>

<script>
//Components
import EntityAutocomplete from '@/components/Shared/Autocomplete/EntityAutocomplete'
import CompanyOptions from '@/views/users/user/component/CompanyOptions'
//Endpoints
import companyEndpoint from '@/endpoints/core/CompanyEndpoint'
import menuEndpoint from '@/endpoints/safe/MenuEndpoint'
import toast from '@/global/ToastConfig'
import accessEndpoint from '@/endpoints/core/AccessEndpoint'
import md5 from 'md5'

export default {
  name: 'User',
  components: { EntityAutocomplete, CompanyOptions },
  props: ['accessCode'],
  data() {
    return {
      code: null,
      currentTab: 0,
      forceRender: 0,
      isLoading: false,
      selectedStatus: null,
      email: null,
      entity: {
        code: null,
        identification: '',
        name: '',
      },
      companiesList: [],
      currentCompany: new Set(),
      selectedAccess: [],
      appList: [],
      companiesIds: [],
      statusList: [
        { code: 'A', title: 'Activo' },
        { code: 'I', title: 'Inactivo' },
        { code: 'D', title: 'Eliminado' },
      ],
      menu: [],
      accessInfo: null,
      companiesCodeList: [],
      profileCompanies: [],
      idsToRemove: [],
    }
  },

  async mounted() {
    this.isLoading = true
    this.companiesList = await companyEndpoint.listCompanies()
    const menuList = await menuEndpoint.listMenu()
    this.menu = this.processMenu(menuList)

    if (this.accessCode) {
      this.companiesCodeList = this.listCompanyCode(this.companiesList)
      const accessInfo = await accessEndpoint.findByAccessCode(this.accessCode)
      this.accessInfo = accessInfo
      if (this.accessInfo == null) {
        this.isLoading = false
        toast.error('No se encontraron programas asignados')
        this.$router.push('/view/users/management')
        return
      }
      this.removeDuplicateCompany(accessInfo)
      this.assignData(accessInfo)
      this.processSelection()
    }
    this.isLoading = false
  },
  watch: {
    entity() {
      this.email = ''
      if (!(this.entity && this.entity.email)) {
        return
      }
      const emails = JSON.parse(this.entity.email)
      if (emails && emails.length > 0) {
        this.email = emails[0].email
      }
    },
    selectedAccess() {
      if (this.accessCode > 0) {
        this.fillData()
      }
    },
  },
  methods: {
    select(node) {
      this.changeDisabledStatus(node, true)
      this.companiesList = [...this.companiesList]
      setTimeout(() => this.removeCompanies(), 50)
    },
    deselect(node) {
      this.changeDisabledStatus(node, false)
      this.companiesList = [...this.companiesList]
      setTimeout(() => this.removeCompanies(), 50)
    },
    removeCompanies() {
      if (this.idsToRemove.length > 0) {
        const newIds = [...this.companiesIds]
        this.idsToRemove.forEach((code) => {
          const index = newIds.indexOf(code)
          if (index > -1) {
            newIds.splice(index, 1)
          }
        })
        this.idsToRemove = []
        this.companiesIds = newIds
      }
      this.processSelection()
    },
    changeDisabledStatus(item, isDisabled) {
      if (!item.children) {
        return
      }
      item.children.forEach((child) => {
        this.idsToRemove.push(child.code)
        child.isDisabled = isDisabled
        this.changeDisabledStatus(child, isDisabled)
      })
    },
    listCompanyCode(companiesList) {
      let list = []
      companiesList.forEach((item) => {
        list.push(item.code)
        if (item.children) {
          list = [...list, ...this.listCompanyCode(item.children)]
        }
      })
      return list
    },
    assignData(info) {
      this.code = this.accessCode ? this.accessCode : null
      this.entity.code = info[0].entity.code
      this.entity.identification = info[0].entity.identification
      this.entity.name = info[0].entity.name
      this.selectedStatus = info[0].status
      this.email = info[0].email
    },
    removeDuplicateCompany(info) {
      info.forEach((item) => {
        item.detailList.forEach((detailList) => {
          this.currentCompany.add(detailList.company.code)
        })
      })
      this.profileCompanies = [...this.currentCompany]
      this.companiesIds = [
        ...this.profileCompanies.filter((item) =>
          this.companiesCodeList.includes(item)
        ),
      ]
    },

    appListProcess(selectedAccessAppList, appCode, permissions) {
      selectedAccessAppList.forEach((selectedAccessAppList) => {
        selectedAccessAppList.children.forEach((children) => {
          if (children.app.code === undefined) {
            children.children.forEach((children) => {
              if (children.app.code === appCode) {
                children.permissions = JSON.parse(permissions)
              }
            })
          }
          if (children.app.code === appCode) {
            children.permissions = JSON.parse(permissions)
          }
        })
      })
    },

    detailListProcess(detailList, company, selectedAccessAppList) {
      detailList.forEach((detailList) => {
        if (detailList.company.code !== company) {
          return
        }
        detailList.appList.forEach((appList) => {
          if (appList.permissions) {
            this.appListProcess(
              selectedAccessAppList,
              appList.app.code,
              appList.permissions
            )
          }
        })
      })
    },
    fillData() {
      this.selectedAccess.forEach((selectedAccess) => {
        const company = selectedAccess.company.code
        this.accessInfo.forEach((accessInfo) => {
          this.detailListProcess(
            accessInfo.detailList,
            company,
            selectedAccess.appList
          )
        })
      })
    },
    processMenu(appList) {
      let newMenu = []
      for (let i = 0; i < appList.length; i++) {
        const menu = appList[i]
        const children = menu.children
        const isApp = menu.app
        let newApp = { app: { label: menu.label } }
        if (isApp) {
          menu.app.label = menu.label
          newApp = { app: menu.app }
        }
        if (children) {
          newApp.children = this.processMenu(children)
        }
        newMenu.push(newApp)
      }
      return newMenu
    },
    processSelection() {
      let list = []
      this.companiesIds.forEach((companyId) => {
        const company = this.findCompany(this.companiesList, companyId)
        if (company) {
          const cardIdUsuCode = this.getCardIdUsuCode()
          const access = {
            company,
            appList: structuredClone(this.menu),
            cardId: cardIdUsuCode.cardIds,
            usucodigo: cardIdUsuCode.usucodigo,
          }
          list.push(access)
        }
      })
      this.selectedAccess = list
      this.forceRender++
    },
    getCardIdUsuCode() {
      let result = { cardIds: null, usuCodes: null }
      if (this.accessInfo) {
        this.accessInfo.forEach((item) => {
          item.detailList.forEach((detail) => {
            result.cardIds = detail.cardId
            result.usucodigo = detail.usucodigo
          })
        })
      }
      return result
    },
    findCompany(list, companyId) {
      for (let i = 0; i < list.length; i++) {
        const currentCompany = list[i]
        if (currentCompany.code === companyId) {
          return currentCompany
        }
        const children = currentCompany.children
        if (!children) {
          continue
        }
        const companyInfo = this.findCompany(children, companyId)
        if (companyInfo) {
          return companyInfo
        }
      }
    },
    validate() {
      if (!this.entity) {
        toast.error('Debe seleccionar una empresa', '')
        return false
      }

      if (!this.selectedStatus) {
        toast.error('Debe seleccionar un estado')
        return false
      }

      if (!this.email) {
        toast.error('Debe ingresar un correo electrónico')
        return false
      }

      return true
    },
    save() {
      if (!this.validate()) {
        return
      }

      let newAppAccess = []
      this.selectedAccess.forEach((item) => {
        const newItem = structuredClone(item)
        const newList = []
        this.processPermission(item.appList, newList)
        if (newList && newList.length > 0) {
          newItem.appList = newList
          newAppAccess.push(newItem)
        }
      })
      const access = {
        code: this.code,
        entity: this.entity,
        email: this.email,
        secret: md5(this.entity.identification),
        status: this.selectedStatus,
        detailList: newAppAccess,
        change: 'Y',
      }
      this.isLoading = true
      accessEndpoint.save(access).then((result) => {
        this.isLoading = false
        if (result <= 0) {
          return
        }
        this.cleanData()
        this.companiesIds = []
        this.removeCompanies()
        this.isLoading = false
        if (this.accessCode) {
          this.$router.push('/view/users/management')
        }
      })
    },
    processPermission(appList, newList) {
      appList.forEach((item) => {
        const permissions = item.permissions
        const isGranted =
          permissions &&
          (!!permissions.read ||
            !!permissions.write ||
            !!permissions.update ||
            !!permissions.delete)
        if (item.app && item.app.code && isGranted) {
          newList.push({
            app: { code: item.app.code },
            permissions: JSON.stringify(permissions),
          })
        }
        if (item.children) {
          this.processPermission(item.children, newList)
        }
      })
    },
    validateSave() {
      if (!this.entity || !this.entity.code) {
        throw new Error(
          'Debe seleccionar un tercero para poder asignar el usuario'
        )
      }
      if (!this.email) {
        throw new Error('Debe ingresar un correo electrónico')
      }
      if (!this.selectedAccess || this.selectedAccess.length === 0) {
        throw new Error('Debe seleccionar al menos una empresa')
      }
    },
    cleanData() {
      this.code = null
      this.entity.code = null
      this.entity.identification = null
      this.entity.name = null
      this.selectedStatus = null
      this.email = null
    },
    deleteCompany(index, company) {
      toast
        .ask(this, '¿Está seguro de eliminar la compañía?')
        .then((result) => {
          if (result) {
            this.companiesIds.splice(index, 1)
            this.deselect(company)
          }
        })
    },
  },
}
</script>

<style>
.con-vs-card .vs-card--content,
.con-vs-card .vs-card--header {
  padding: 12px 20px;
  margin-bottom: 5px;
}

.column {
  padding: 0.4rem 0.75rem;
}
</style>
